import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { lazy } from 'react';
import { AuthProvider } from './context/AuthContext';
import DefaultLayout from '@components/Layouts/DefaultLayout';
import { ThemeProvider } from '@mui/material';
import theme from '@utils/theme/theme';
import { ProtectedRoute } from '@components/util/ProtectedRoute';
import Snackbar from '@components/util/snackbar/Snackbar';
import LazyRoute from '@components/util/LazyRoute';
import { useLocale } from './i18n/LocaleContext';

const OnboardingPage = lazy(() => import('./components/Onboarding/OnboardingPage'));
const Dashboard = lazy(() => import('./components/Dashboard'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const LogoutPage = lazy(() => import('./pages/LogoutPage'));
const StockContainer = lazy(() => import('./components/Stocks/StockContainer'));
const SignalEvaluationOverview = lazy(
  () => import('./components/SignalEvaluations/SignalEvaluationOverview'),
);

function App() {
  const { t } = useLocale();
  const route = (key: string, element: React.ReactNode) => (
    <LazyRoute
      key={key}
      loadingLabel={t('common.routeLoading')}
      errorLabel={t('common.routeLoadError')}
      retryLabel={t('common.retry')}
    >
      {element}
    </LazyRoute>
  );

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AuthProvider>
          <Routes>
            <Route element={<DefaultLayout />}>
              <Route path="/login" element={route('login', <LoginPage />)} />
              <Route path="/logout" element={route('logout', <LogoutPage />)} />

              <Route element={<ProtectedRoute />}>
                <Route path="/" element={route('dashboard', <Dashboard />)} />
                <Route path="/imports" element={route('imports', <OnboardingPage />)} />
                <Route path="/stocks" element={route('stocks', <StockContainer />)} />
                <Route
                  path="/signal-evaluations"
                  element={route('evaluations', <SignalEvaluationOverview />)}
                />
                {/* <Route path="/profile" element={<ProfilePage />} /> */}
              </Route>
            </Route>
          </Routes>
        </AuthProvider>
      </Router>
      <Snackbar />
    </ThemeProvider>
  );
}

export default App;
